import { render, staticRenderFns } from "./league.vue?vue&type=template&id=256f8a40"
import script from "./league.vue?vue&type=script&lang=js"
export * from "./league.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports